import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit {
  user : firebase.User;
  constructor(private afAuth:AngularFireAuth) {
    afAuth.authState.subscribe( user => this.user = user);
  }

  ngOnInit() {
  }

}
